import { BarChart2 } from '@griply/assets';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Colors, Sizes, Variants } from 'shared/components/ui/button';
import { EmptyState } from 'shared/components/ui/empty-state';

export type ProgressEmptyStateProps = {
  onSelectMetric?: () => void;
};

export const ProgressEmptyState: React.FC<ProgressEmptyStateProps> = ({
  onSelectMetric,
}) => {
  const { t } = useTranslation();

  return (
    <EmptyState
      icon={BarChart2}
      title={t('pages.goal-detail.progress.empty.title')}
      description={t('pages.goal-detail.progress.empty.description')}
    >
      <Button
        variant={Variants.Contained}
        color={Colors.Primary}
        size={Sizes.Small}
        onClick={onSelectMetric}
      >
        {t('pages.goal-detail.progress.empty.button')}
      </Button>
    </EmptyState>
  );
};
